import axios from '@/plugins/axios';

const loginWithCredentials = async (
  loginName: string,
  password: string,
): Promise<any> => {
  const response = await axios.post('/v1/users/user/login', { loginName, password });
  return {
    ...response.data,
    token: response.headers.authorization,
    refreshToken: response.headers.refresh_token,
  };
};

const loginWithToken = async (token: string): Promise<any> => {
  const response = await axios.get(`/v1/users/user/token/${token}`);
  return {
    ...response.data,
    token: response.headers.authorization,
    refreshToken: response.headers.refresh_token,
  };
};

export default {
  loginWithCredentials,
  loginWithToken,
};
